import { ServerSummary } from '@activia/cm-api';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { ServerOverviewService } from './server-overview.service';

@Component({
  selector: 'amp-server-overview',
  styleUrls: ['./server-overview.component.scss'],
  templateUrl: './server-overview.component.html',
})
export class ServerOverviewComponent implements OnInit, OnDestroy {
  @Input() title: string;

  overview$: Observable<ServerSummary>;
  memPercent$: Observable<number>;
  cpuLoad$: Observable<number>;
  diskPercent$: Observable<number>;

  systemLoadProcessorLabels: any = {
    '=0': '',
    '=1': 'dashboardScope.dashboard.server.processors.singular_15',
    other: 'dashboardScope.dashboard.server.processors.plural_15',
  };

  constructor(private overviewService: ServerOverviewService) {}

  ngOnInit(): void {
    this.overview$ = this.overviewService.serverOverview$;
    this.memPercent$ = this.overviewService.memPercent$;
    this.cpuLoad$ = this.overviewService.cpuLoad$;
    this.diskPercent$ = this.overviewService.diskPercent$;

    this.overviewService.start();
  }

  ngOnDestroy(): void {
    this.overviewService.stop();
  }
}
